import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import { DuxContactsComponent } from "./dux-contact.component";
import { DuxInspectorsComponent } from "./dux-inspectors.component";
import { DuxAdHocComponent } from "./dux-ad-hoc.component";

interface ScheduleDuxCallDialog {
    open: any;
    onDuxCall: () => void;
    onClosed: () => void;
}

export const ScheduleDuxCallDialog = ({ open, onDuxCall, onClosed }: ScheduleDuxCallDialog) => {
    const [value, setValue] = useState<string>('contacts');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
    };

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={'lg'}
            // onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{ p: 2, pt: 1, pb: 1, m: 0 }}>
                Schedule DUX Call
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClosed}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 3,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <DialogContent dividers className="popupDilog">
                <FormControl>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={value}
                        onChange={handleChange}
                    >
                        <FormControlLabel value="contacts" control={<Radio />} label="Contacts" />
                        <FormControlLabel value="inspectors" control={<Radio />} label="Inspectors" />
                        <FormControlLabel value="hoc" control={<Radio />} label="Ad-hoc" />
                    </RadioGroup>
                </FormControl>
                {value == "contacts" && (
                    <DuxContactsComponent customerID={open?.customerID} workOrderID={open?.workOrderID} onDuxCall={onDuxCall} onClosed={onClosed} />
                )}
                {value == "inspectors" && (
                    <DuxInspectorsComponent workOrderID={open?.workOrderID} onDuxCall={onDuxCall} onClosed={onClosed} />
                )}
                {value == 'hoc' && (
                    <DuxAdHocComponent workOrderID={open?.workOrderID} onDuxCall={onDuxCall} onClosed={onClosed} />
                )}
            </DialogContent>
        </Dialog>
    );
}